
import Vue from "vue"

export default Vue.extend({
  layoutSettings: {
    titleToken: "worldYouthFestival",
  },

  data: () => ({
    breadcrumbs: {
      "/": "homepage",
      "/wyf2024": "wyf",
    } as Record<string, string>,
  }),
})
